export const userRoles = {
  customerUser: "customer user",
  operator: "operator",
  business: "business user",
};
